import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faCertificate } from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';
import Carousel from "../../elements/Carousel/Carousel";

const Home = () => {
    const whyUsRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        if (whyUsRef.current) {
            observer.observe(whyUsRef.current);
        }

        return () => {
            if (whyUsRef.current) {
                observer.unobserve(whyUsRef.current);
            }
        };
    }, []);

    return (
        <div className="lern-home">
            <div className="catch-div">
                <div className="wave-div wave-one">
                    <svg className="catch-svg svg-one" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L34.3,208C68.6,192,137,160,206,165.3C274.3,171,343,213,411,213.3C480,213,549,171,617,181.3C685.7,192,754,256,823,256C891.4,256,960,192,1029,176C1097.1,160,1166,192,1234,213.3C1302.9,235,1371,245,1406,250.7L1440,256L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z"></path></svg>
                    <svg className="catch-svg svg-three" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L20,234.7C40,245,80,267,120,250.7C160,235,200,181,240,181.3C280,181,320,235,360,256C400,277,440,267,480,229.3C520,192,560,128,600,133.3C640,139,680,213,720,208C760,203,800,117,840,122.7C880,128,920,224,960,229.3C1000,235,1040,149,1080,128C1120,107,1160,149,1200,176C1240,203,1280,213,1320,229.3C1360,245,1400,267,1420,277.3L1440,288L1440,0L1420,0C1400,0,1360,0,1320,0C1280,0,1240,0,1200,0C1160,0,1120,0,1080,0C1040,0,1000,0,960,0C920,0,880,0,840,0C800,0,760,0,720,0C680,0,640,0,600,0C560,0,520,0,480,0C440,0,400,0,360,0C320,0,280,0,240,0C200,0,160,0,120,0C80,0,40,0,20,0L0,0Z"></path></svg>
                </div>
                <h2>Learn <span className="brand-word">Master</span> Earn</h2>
                <p>Everyone deserves a complete learning experience. For us, it's not just what you learn, but also how you learn.</p>
                <div className="catch-btns">
                    <Link to="/courses">Get Started</Link>
                </div>
                <div className="wave-div wave-two">
                    <svg className="catch-svg svg-two" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L34.3,208C68.6,192,137,160,206,165.3C274.3,171,343,213,411,213.3C480,213,549,171,617,181.3C685.7,192,754,256,823,256C891.4,256,960,192,1029,176C1097.1,160,1166,192,1234,213.3C1302.9,235,1371,245,1406,250.7L1440,256L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"></path></svg>
                    <svg className="catch-svg svg-three" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 320"><path fill-opacity="1" d="M0,224L20,234.7C40,245,80,267,120,250.7C160,235,200,181,240,181.3C280,181,320,235,360,256C400,277,440,267,480,229.3C520,192,560,128,600,133.3C640,139,680,213,720,208C760,203,800,117,840,122.7C880,128,920,224,960,229.3C1000,235,1040,149,1080,128C1120,107,1160,149,1200,176C1240,203,1280,213,1320,229.3C1360,245,1400,267,1420,277.3L1440,288L1440,320L1420,320C1400,320,1360,320,1320,320C1280,320,1240,320,1200,320C1160,320,1120,320,1080,320C1040,320,1000,320,960,320C920,320,880,320,840,320C800,320,760,320,720,320C680,320,640,320,600,320C560,320,520,320,480,320C440,320,400,320,360,320C320,320,280,320,240,320C200,320,160,320,120,320C80,320,40,320,20,320L0,320Z"></path></svg>
                </div>
            </div>
            <div className="vision-mission">
                <div className="vision-div">
                    <div className="term">
                        Vision
                    </div>
                    <div className="desc">
                        To become a leading global technology learning platform, recognized for developing skilled professionals, nuturing innovation, and creating opportunities for learners to excel in the ever-evolving tech industry
                    </div>
                    <div className="v-img">
                        <img src="/images/Pattern_course_name.png" alt="Course Name" />
                    </div>
                </div>
                <div className="mission-div">
                    <div className="term">
                        Mission
                    </div>
                    <div className="desc">
                        To provide accessible, practical and high-quality technology education that empowers individuals to build successful careers and make meaningful contributions in te digital world
                    </div>
                    <div className="m-img">
                        <img src="/images/Pattern_course_name.png" alt="Course Name" />
                    </div>
                </div>
            </div>
            <div className={`why-us ${isVisible ? 'slide-up' : ''}`} ref={whyUsRef}>
                <div className="wu-item">
                    <div className="wu-item-head">
                        <h3>Step-by-Step Learning</h3>
                        <div className="wu-icon">
                            <FontAwesomeIcon icon={faLayerGroup} />
                        </div>
                        <div className="wu-img">
                            <img src="/images/Pattern_course_name.png" alt="Course Name" />
                        </div>
                    </div>
                    <p className="wu-item-desc">
                        We follow a properly graduated training approach to make learning easy, even if you have zero knowledge of the course.
                    </p>
                </div>
                <div className="wu-item">
                    <div className="wu-item-head">
                        <h3>Getting Certified</h3>
                        <div className="wu-icon">
                            <FontAwesomeIcon icon={faCertificate} />
                        </div>
                        <div className="wu-img">
                            <img src="/images/Pattern_course_name.png" alt="Course Name" />
                        </div>
                    </div>
                    <p className="wu-item-desc">
                        Certificates earned on your tech skills avail you a valid means to make you more appealing to potential employers.
                    </p>
                </div>
            </div>
            <h1 className="testimonial">Some Students' Testimonials</h1>
            <div className="review-div">
                <Carousel />
            </div>
            <div className="meet-dickson">
                <img src="/images/profilepic.png" alt="Dickson's Profile" />
                <p className="meet-name">Dickson Onyedumekwu</p>
                <p>My principle is simple, not different from God's principle - 'Be fruitful and multiply'. My fulfilment comes from my success in reproducing better versions of myself in others.</p>
                <a href="https://lerntutors.com/myprofile" target="_blank" rel="noreferrer">Meet the Lead Tutor</a>
            </div>
        </div>
    )
}

export default Home;